import {Modal} from '@/components/atoms';
import {ModalTableContent} from '@/components/molecules';
import {usePrerequisiteTarget} from '@/hooks/usePrerequisiteTarget';
import {setPrerequisiteTarget} from '@/store/slices/salesTargetSlice';
import {SELECTION_TYPE} from '@/utils/constants/commonConstants';
import {MODAL_TYPE} from '@/utils/constants/globalStyle';
import React, {useCallback, useMemo, useState} from 'react';
import {useDispatch} from 'react-redux';
import PropTypes from 'prop-types';

const PrerequisiteTarget = ({openTarget, setOpenTarget, setFormData}) => {
  const [rowSelection, setRowSelection] = useState({});
  const [selectedRowData, setSelectedRowData] = useState([]);
  const dispatch = useDispatch();

  // Memoized Handlers
  const isCloseModal = useCallback(() => {
    setOpenTarget(!openTarget);
    setRowSelection({});
  }, [openTarget, setOpenTarget]);

  const handlePrerequisite = useCallback(() => {
    setFormData((prev) => ({
      ...prev,
      ...{preRequisiteTarget: selectedRowData?.[0]?.Name}
    }));
    dispatch(setPrerequisiteTarget(selectedRowData?.[0]?.Name));
    setOpenTarget(!openTarget);
  }, [dispatch, openTarget, selectedRowData, setFormData, setOpenTarget]);

  // Memoized Columns
  const columns = useMemo(
    () => [
      {columnKey: 'Name', header: 'Name'},
      {columnKey: 'Description', header: 'Description'},
      {columnKey: 'ModifiedDate', header: 'Modified Date'}
    ],
    []
  );

  const {prerequisiteTargetData} = usePrerequisiteTarget();
  return (
    <Modal
      isDark={true}
      onCloseModal={isCloseModal}
      className='prerequisite-target-modal'
      onClickSecondaryButton={isCloseModal}
      onClickPrimaryButton={handlePrerequisite}
      showSecondaryButton={true}
      showModal={openTarget}
      title='Choose Prerequisite Target'
      text='Please select only one sales target as prerequisite.'
      primaryButtonText={'Done'}
      primaryButtonDisabled={Object.keys(rowSelection)?.length !== 1}
      content={
        <ModalTableContent
          data={{items: prerequisiteTargetData}}
          columns={columns}
          tableHeader={'Active Targets'}
          size='small'
          isDark={true}
          rowSelection={rowSelection}
          selection={SELECTION_TYPE.MULTIPLE}
          setRowSelection={setRowSelection}
          setSelectedRowData={setSelectedRowData}
          showColumnFilters={false}
        />
      }
      type={MODAL_TYPE.MEDIUM}
    />
  );
};

PrerequisiteTarget.propTypes = {
  openTarget: PropTypes.bool.isRequired,
  setOpenTarget: PropTypes.func.isRequired,
  setFormData: PropTypes.func.isRequired
};

export default React.memo(PrerequisiteTarget);
